import Vue from 'vue'
import App from './App.vue'
import { router } from './router/index';
import UxCool from '@cloud-sn/uxcool';
import '@cloud-sn/uxcool/dist/uxcool.css';
import '@/style/common.css';

Vue.config.productionTip = false;
Vue.use(UxCool);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

Date.prototype.Format = function (format) {
	var date = {
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"h+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		"S+": this.getMilliseconds(),
	};
	if (/(y+)/i.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in date) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
		}
	}
	return format;
};